function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

export function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}
